import React, { useState } from "react";
import { Button, Card } from 'react-bootstrap';
import "./CardItem.scss";
import Icons from "../../../components/Icons/Icons";
import axios from 'axios';
import { useMessageError } from '../../../hooks/message.hook';
import { Link, useNavigate } from "react-router-dom";
import { getWishListOperation as getWishList } from "../../../store/wishList/operations";
import { useDispatch } from "react-redux";
import AddToCartButton from "../../AddToCartButton/AddToCartButton";
import PriceBlock from "../../PriceBlock/PriceBlock";
import defaultImg from '../../../theme/assets/images/pexels-rethaferguson-3059609.jpg';
import DiscountTimer from "../../DiscountTimer/DiscountTimer";
import { isDiscountValid } from '../../../utils/discountHelper';

const CardItem = ({ auth, item, wishProduct }) => {
    const messageError = useMessageError();
    const dispatch = useDispatch();
    const [iconColor, setIconColor] = useState(wishProduct[item._id] ? "#000000" : "");
    const navigate = useNavigate();
    const admin = auth.permissions?.admin?.access;
    const [ml, setMl] = useState(1);

    const choiceMl = (ml) => {
        setMl(ml);
    };
    const onSubmit = async (id) => {
        try {
            let mainUrl = "";
            const config = {};
            if (auth.isAuthenticated) {
                config.headers = { "Authorization": `Bearer ${auth.token}` };
                mainUrl = admin ? "admin" : "customer";
            }

            const response = await axios.post(`/api/${mainUrl}/wishlist/${id}`, id, config);

            // Update local storage with the new wishlist
            localStorage.setItem("wishlist", JSON.stringify(response.data.data));

            // Update wishProduct state
            const updatedWishProduct = {};
            response.data.data.products.forEach((prod) => {
                updatedWishProduct[prod._id] = true;
            });

            // Set icon color based on the wishlist state
            if (updatedWishProduct[id]) {
                setIconColor("#000000");
            } else {
                setIconColor("");
            }

            // Dispatch the updated wishlist
            dispatch(getWishList(admin));

        } catch (error) {
            messageError(error.response?.data?.message || "Something went wrong");
        }
    };

    const toProduct = (id) => {
        navigate(`/products/item/${id}`);
    };

    const getDiscountInfo = () => {
        // Спочатку перевіряємо знижку категорії
        if (item.categories?.discount && isDiscountValid(item.categories.discount)) {
            const categoryDiscount = item.categories.discount;
            
            // Якщо є знижка на товарі (не 0), вона має пріоритет, але дата з категорії
            if (item.discount && item.discount > 0) {
                return {
                    name: "Знижка на товар",
                    endDate: categoryDiscount.dateEnd,
                    hasTimer: !!categoryDiscount.dateEnd
                };
            }
            
            // Інакше повертаємо знижку категорії
            return {
                name: categoryDiscount.name,
                endDate: categoryDiscount.dateEnd,
                hasTimer: !!categoryDiscount.dateEnd
            };
        }
        
        // Якщо немає дійсної знижки категорії, перевіряємо знижку товару
        if (item.discount && item.discount > 0) {
            return {
                name: "Знижка на товар",
                endDate: null,
                hasTimer: false
            };
        }
        
        return null;
    };

    const discountInfo = getDiscountInfo();

    return (
        // <div className="goods__tile-wrapper animated_card">
            <Card className="goods-tile position-relative ">
                <Card.Img 
                    className="card_image cursor-pointer" 
                    onClick={() => toProduct(item._id)}
                    variant="top" 
                    src={item.imageFirst ? item.imageFirst : `${defaultImg}`}  
                />
                {auth.isAuthenticated && (
                    <div key={item._id} style={{ cursor: 'pointer' }}>
                        <Icons
                            type="navHeart"
                            color="black"
                            onClick={() => onSubmit(item._id)}
                            filled={iconColor}
                            width={25}
                            height={25}
                        />
                    </div>
                )}
                <Card.Body>
                    <Card.Title className="goods-tile__name-block cursor-pointer">
                        <Link to={`/products/item/${item._id}`} className="goods-tile__name">{item.name}</Link>
                    </Card.Title>
                    <div className="d-flex justify-content-between">
                        <PriceBlock
                            className="mb-3"
                            previousPrice={item.previousPrice}
                            currentPrice={item.currentPrice}
                            product={item}
                        />
                        <AddToCartButton key={item._id}
                            admin={!!admin}
                            product={item}
                            id={item._id}
                            orderButton={false}
                            currentPrice={item.currentPrice}
                            ml={ml}
                        />
                    </div>
                    {/* {discountInfo && discountInfo.hasTimer && (
                        <DiscountTimer 
                            endDate={discountInfo.endDate}
                            discountName={discountInfo.name}
                            compact={true}
                        />
                    )} */}
                </Card.Body>
            </Card>
        // </div>
    );
};

export default CardItem;
